import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUsers, FaLightbulb, FaRocket } from 'react-icons/fa';
import teamActionImage from '../assets/images/team-action.jpg';
import './AboutSection.css';

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section className="about-section" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">{t('about.title')}</h2>
            <p className="section-subtitle">
              {t('about.subtitle')}
            </p>
            <div className="about-features">
              <div className="feature">
                <FaUsers className="feature-icon" />
                <h3>{t('about.features.team.title')}</h3>
                <p>{t('about.features.team.description')}</p>
              </div>
              <div className="feature">
                <FaLightbulb className="feature-icon" />
                <h3>{t('about.features.innovation.title')}</h3>
                <p>{t('about.features.innovation.description')}</p>
              </div>
              <div className="feature">
                <FaRocket className="feature-icon" />
                <h3>{t('about.features.results.title')}</h3>
                <p>{t('about.features.results.description')}</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="image-container">
              <img src={teamActionImage} alt={t('about.imageAlt')} />
              <div className="experience-badge">
                <span className="years">5+</span>
                <span className="text">{t('about.experience')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
